/**
 * Title bar for the staff billing area — every billing page's chrome row.
 *
 * The billing pages live outside the customer scope the automatic
 * breadcrumbs model, so this bar builds the area's own trail: the Billing
 * Management root, any section crumbs the view passes (e.g. Account
 * Management above an account), and the page title as the current crumb.
 * Also appends the QuickBooks connection chip for QuickBooks users.
 *
 * Contains:
 * - BillingTitleBar — TitleBar wrapper with the billing trail (default export)
 */
import React from 'react';
import { useTranslation } from 'react-i18next';

import { useUser } from '@sophocles/app';
import TitleBar from '@sophocles/components/App/TitleBar';
import QuickBooksChip from '@sophocles/views/billing/components/QuickBooksChip';

function BillingTitleBar({ title, showBackButton, items = [], crumbs = [] }) {
  const { t } = useTranslation();
  const { permissions: isQuickBooksUser } = useUser();

  // Root self-reference collapses when a page titles itself with the root
  // label: the root crumb is then the current page and gets no duplicate.
  // /billing redirects to the accounts list — there is no dashboard page.
  const rootLabel = t('billing.billing', 'Billing');
  const trail = [{ label: rootLabel, to: '/billing', type: 'billing' }, ...crumbs];
  const breadcrumbs = title && title !== rootLabel ? [...trail, { label: title }] : trail;

  return (
    <TitleBar
      title={title}
      breadcrumbs={breadcrumbs}
      showBackButton={showBackButton ?? false}
      sx={{ px: 1 }}
      items={[...items, isQuickBooksUser && <QuickBooksChip key="quickBooks" />]}
    />
  );
}

export default BillingTitleBar;
